import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { appConfig } from '../../config/appConfig';

const WhatsAppButton: React.FC = () => {
  if (!appConfig.socialLinks.whatsapp) {
    return null;
  }

  return (
    <div className="whatsApp-fix">
      <span>Parla</span>
      <a 
        className='link-green' 
        target="_blank" 
        rel="noopener noreferrer"
        href={appConfig.socialLinks.whatsapp}
      >
        <FontAwesomeIcon icon={faWhatsapp} title="Contattami su WhatsApp" />
      </a>
      <span>con me</span>
    </div>
  );
};

export default WhatsAppButton;